import { EmptyState } from '@backstage/core-components';
import { EntityRefLink } from '@backstage/plugin-catalog-react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { hierachyProps } from '../../redux/slices/hierachySlice';
import useCustomEntities from '../../hooks/useEntities';
import { Entity } from '@backstage/catalog-model';



const TeamProductsList: FC<{
  productData?: Omit<hierachyProps, 'loading' | 'error'>;
  title: string;
  classes: any;
  entity:Entity
}> = ({ productData, title, classes,entity }) => {
    const isVs=window?.location?.pathname?.split('/')[4]?.toLowerCase().includes('_vs_');
    const isArt=window?.location?.pathname?.split('/')[4]?.toLowerCase().includes('_art_');
    const isCop=window?.location?.pathname?.split('/')[4]?.toLowerCase().includes('_cop_');
    const isPlt=window?.location?.pathname?.split('/')[4]?.toLowerCase().includes('_plt_');

    const {getCustomEntitiesByKind}=useCustomEntities('System');
    const {getCustomEntitiesByKind:groupList}=useCustomEntities('Group');
    const {getCustomEntitiesByKind:groupInfoList}=useCustomEntities('GroupInfo');
    const [productsList,setProductList]=useState<Entity[]>([])
    const getOwnerProducts=useCallback(async()=>{
        const allProducts=(await getCustomEntitiesByKind()).items;
        const allGroupInfoList=(await groupInfoList()).items;
        const allGroups=(await groupList()).items;
        const productManagersByVS=entity?.spec?.contacts as any;
        if(isVs){
          // get the ValueStream children (Value Stream)
          const name=window?.location?.pathname?.split('/')[4]?.toLowerCase()
          const vsArtList=allGroups.find(x=>x.metadata.name?.toLowerCase()===name);
          if(vsArtList){
            const relations=vsArtList.relations?.filter(y=>y.targetRef?.includes('_art_'));
            const entityObjectIdList=allGroups?.filter(x=>relations?.some(y=>y.targetRef?.replaceAll('group:default/','')?.toLowerCase()===x.metadata.name?.toLowerCase()))
            
            if(entityObjectIdList && entityObjectIdList.length>0){
               const contactList=entityObjectIdList.map((item: Entity) => {
                const entraGroupObjectId=item?.metadata?.annotations?.['graph.microsoft.com/group-id'];
                return allGroupInfoList?.find(x =>{
                  const id=x?.spec?.entraGroupObjectId as any
                  return id.toLowerCase()===entraGroupObjectId?.toLowerCase()
                })?.spec?.contacts
               }) as Array<any>
               const flatContactList = contactList?.flat().filter(Boolean);
               const productsListVs=allProducts?.filter(item=>flatContactList?.some((manager: { link: string })=>item.spec?.owner===manager.link)) 
               const products=allProducts?.filter(item=>productManagersByVS?.some((manager: { link: string })=>item.spec?.owner===manager.link))
               const combinedList=[...productsListVs,...products];
               const filterProducts=combinedList?.flat()?.filter((item,index,self)=>{
                return self.findIndex(x=>x.metadata.title===item.metadata.title)===index
               })
              setProductList(filterProducts)

              }
              return;
          }
        }
        // const productManagerFilter=productManagersByVS?.filter((x: { role: string; })=>x.role?.toLowerCase()==='product manager') as contacts[]
       const products=allProducts?.filter(item=>productManagersByVS?.some((manager: { link: string })=>item.spec?.owner===manager.link))
       setProductList(products)
    },[entity,window?.location?.pathname])

  
    

    useEffect(()=>{
      if(entity||isVs||isArt||isCop||isPlt)
    getOwnerProducts()
    },[entity,getOwnerProducts,isVs])
  
  return (
    <Card data-testid="entity-has-systems-card">
      <div style={{ display: 'flex' }}>
        <CardHeader title={title} style={{ marginBottom: '17px' }} />
        <span style={{ marginTop: '15px' }}>
          <Tooltip
          title={
            'These should be the products that are assigned to the PMs that belong to the VS/ART'
          }
          placement="top"
          arrow
        >
          <IconButton size="small">
            <button className={`${classes}`}>?</button>
          </IconButton>
        </Tooltip>
        </span>
      </div>
      <Divider />
      <CardContent>
        {productData?.response &&
        productData?.response.length > 0 && !isVs &&!isArt&&!isCop&&!isPlt&&
        productData?.response?.[0]?.product ? (
          <>
            <Table
              aria-label="group list"
              size="small"
              style={{ width: '100%' }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell style={{ paddingLeft: '200px' }}>
                    Product Manager
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData?.response
                  ?.filter((x: { product: any }) => x.product)
                  .filter(
                    (
                      item: { product: { title: any } },
                      index: any,
                      self: any[],
                    ) =>
                      self.findIndex(
                        y => y.product.title === item.product.title,
                      ) === index,
                  )
                  .flatMap((row, rowIndex: any) => {
                    let parsedProducts: any[] = [];

                    try {
                      if (typeof row.product === 'string') {
                        parsedProducts = JSON.parse(row.product);
                      } else {
                        parsedProducts.push(row.product);
                      }
                    } catch (e) {
                      console.warn('Invalid JSON in row.product:', row.product);
                    }

                    return parsedProducts
                      .filter(
                        (item, index, self) =>
                          self.findIndex(x => x.title === item.title) === index,
                      )
                      .map((product: any, i: number) => (
                        <TableRow key={`${rowIndex}-${i}`}>
                          <TableCell>
                            <EntityRefLink entityRef={product?.entityRef}>
                              <b>{product?.title}</b>
                            </EntityRefLink>
                          </TableCell>

                          <TableCell style={{ paddingLeft: '200px' }}>
                            <EntityRefLink
                              entityRef={product?.productOwner?.toLowerCase()}
                            />
                          </TableCell>
                        </TableRow>
                      ));
                  })}
              </TableBody>
            </Table>
          </>
        ) : (isVs||isArt||isCop||isPlt) && productsList && productsList.length>0? (

           <Table
              aria-label="group list"
              size="small"
              style={{ width: '100%' }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell style={{ paddingLeft: '200px' }}>
                    Product Manager
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  productsList.map((item,index)=>{
                    return <TableRow key={`${index}-${item}`}>
                          <TableCell>
                            <EntityRefLink entityRef={item}>
                              <b>{item?.metadata?.title}</b>
                            </EntityRefLink>
                          </TableCell>

                          <TableCell style={{ paddingLeft: '200px' }}>
                            <EntityRefLink
                              entityRef={item.spec?.owner?.toLocaleString().toLowerCase() as any}
                            />
                          </TableCell>
                        </TableRow>
                  })
                }
                
              </TableBody>
              </Table>
        ): (
          <EmptyState
            missing="data"
            title="No teams is responsible for any products."
          />
        )}
      </CardContent>
    </Card>
  );
};

export default TeamProductsList;
